// NOTE This file is auto-generated by @momo/mdx
import allBlogPosts from './BlogPost/index.json'
import allProjects from './Project/index.json'
import allPages from './Page/index.json'

export { allBlogPosts, allProjects, allPages }

export const allDocuments = [...allBlogPosts, ...allProjects, ...allPages]
